import React, { memo, useContext, useMemo } from 'react';
import { findMenuRenderAsAtPath } from '@signal/core/menuService/utils';
import MenuServiceContext from '@signal/core/menuService/Context';
import { Nav, NavLink } from '../Nav';

function ServiceMenuNav(_ref) {
  var location = _ref.location,
      onNavigate = _ref.onNavigate;

  var _useContext = useContext(MenuServiceContext),
      _useContext$response = _useContext.response,
      serviceMenu = _useContext$response === void 0 ? [] : _useContext$response;

  var pathname = location.pathname;
  var headerTabs = useMemo(function () {
    return findMenuRenderAsAtPath(serviceMenu, pathname);
  }, [serviceMenu, pathname]);
  return /*#__PURE__*/React.createElement(Nav, {
    exact: true,
    location: location
  }, headerTabs.map(function (_ref2) {
    var name = _ref2.name,
        link = _ref2.link; // pull out any sub-label text, like "(Beta)".
    // such text should come at the end of the string and be wrapped in parenthesis

    var sub = name.match(/\([^)]+\)$/);

    if (sub) {
      sub = sub[0];
      name = name.replace(sub, '').trim();
    }

    return /*#__PURE__*/React.createElement(NavLink, {
      key: name,
      label: name,
      onClick: onNavigate,
      sublabel: sub,
      to: link
    });
  }));
}

export default /*#__PURE__*/memo(ServiceMenuNav);